import {
  ImagesSkusHouseSvg,
  ImagesSkusArrowRightSvg,
} from '@/assets/images_skus.assets';
import { SkuMobileBreadCrumbsProps } from '@/types/props/components/skus';
import {
  createCategoryUrl,
  createCountyOfOriginUrl,
} from '@/utilites/algolia/create-algolia-urls';
import Image from 'next/image';
import Link from 'next/link';
import Container from '@/components/Container';
import isStringNotDefined from '@/utilites/is-string-not-defined';
import ConditionalLink from '@/components/common/ConditionalLink';
export default function SkuMobileBreadCrumbs({
  skuSlug,
  skuCategoryName,
  skuCountryOfOrigin,
  skuName,
}: SkuMobileBreadCrumbsProps) {
  return (
    <Container className="tw-flex tw-items-center tw-gap-2 tw-bg-customGray tw-py-2">
      <Link href={`/`}>
        <Image
          src={ImagesSkusHouseSvg}
          width={12}
          height={12}
          alt="house"
          className="mb-1"
        />
      </Link>
      <Image src={ImagesSkusArrowRightSvg} width={4} height={9} alt="arrow" />
      <ConditionalLink
        className={
          'tw-font-plusJakartaSans tw-font-medium tw-text-xs tw-no-underline tw-text-slate-gray'
        }
        aria-label={`Go to ${skuCategoryName} category`}
        disabled={isStringNotDefined(skuCategoryName)}
        href={createCategoryUrl(String(skuCategoryName))}
      >
        {skuCategoryName}
      </ConditionalLink>
      <Image src={ImagesSkusArrowRightSvg} width={4} height={9} alt="arrow" />
      <Link
        className={
          'tw-font-plusJakartaSans tw-font-medium tw-text-xs tw-no-underline tw-text-slate-gray'
        }
        href={createCountyOfOriginUrl(skuCountryOfOrigin)}
      >
        {skuCountryOfOrigin}
      </Link>
      <Image src={ImagesSkusArrowRightSvg} width={4} height={9} alt="arrow" />

      <Link
        className={
          'tw-font-plusJakartaSans tw-font-medium tw-text-xs tw-no-underline tw-text-text tw-line-clamp-1'
        }
        href={`/${skuSlug}`}
      >
        {skuName}
      </Link>
    </Container>
  );
}
